import segmentPlugin from '@analytics/segment'
import Analytics from 'analytics'

import { AnalyticsAction, AnalyticsPageAction, AnalyticsTrackAction, AnalyticsActionType } from 'types/analytics.type'
import { excludeFalsy, isString } from 'utils/common'

export const analytics = Analytics({
  app: 'tccc-communities-of-practitioners',
  plugins: [
    segmentPlugin({
      writeKey: process.env.REACT_APP_ANALYTICS_SEGMENT_TOKEN,
    }),
  ].filter(excludeFalsy),
})

export const reset = () => {
  analytics.reset()
}

const getAnalyticsTenantAzId = () => analytics?.getState()?.user?.traits?.tenantAzId

const trackPage = ({ payload }: AnalyticsPageAction) => {
  const analyticsTenantAzId = getAnalyticsTenantAzId()
  if (analyticsTenantAzId) {
    analytics.page(
      {
        title: payload,
      },
      {
        agency: analyticsTenantAzId,
      },
    )
  }
}

const trackAction = ({ payload }: AnalyticsTrackAction) => {
  const analyticsTenantAzId = getAnalyticsTenantAzId()
  if (analyticsTenantAzId) {
    if (isString(payload)) {
      analytics.track(payload, {
        agency: analyticsTenantAzId,
      })
    } else {
      const { action, params } = payload

      analytics.track(action, {
        agency: analyticsTenantAzId,
        ...Object.fromEntries(params.map(({ key, value }) => [key, value])),
      })
    }
  }
}

export const trackAnalytics = (action: AnalyticsAction) => {
  switch (action.type) {
    case AnalyticsActionType.page:
      trackPage(action)
      break

    case AnalyticsActionType.action:
      trackAction(action)
      break

    default:
      break
  }
}

export const ANALYTICS_EVENTS = {
  VISIBILITY_PREFERENCES_CLICKED: 'pg_act_communitiesofpractitioners_header_preferences',
  PRACTITIONERS_CT_SLIDER_DOTS_CLICKED: 'pg_act_communitiesofpractitioners_learntogether_sliderdots',
  PRACTITIONERS_CT_SLIDE_RIGHT_ARROW_CLICKED: 'pg_act_communitiesofpractitioners_learntogether_moveright',
  PRACTITIONERS_CT_SLIDE_LEFT_ARROW_CLICKED: 'pg_act_communitiesofpractitioners_learntogether_moveleft',
  PRACTITIONERS_CAROUSEL_RIGHT_ARROW_CLICKED: 'pg_act_communitiesofpractitioners_wereheretohelp_moveright',
  PRACTITIONERS_CAROUSEL_LEFT_ARROW_CLICKED: 'pg_act_communitiesofpractitioners_wereheretohelp_moveleft',
  PRACTITIONERS_CAROUSEL_DOT_CLICKED: 'pg_act_communitiesofpractitioners_wereheretohelp_sliderdots',
  PRACTITIONERS_FILTERS_SEARCH: 'pg_act_communitiesofpractitioners_meetallofourpractitioners_search',
  PRACTITIONERS_FILTERS_OU_SELECTED:
    'pg_act_communitiesofpractitioners_meetallofourpractitioners_selectOUcluster_select',
  PRACTITIONERS_FILTERS_CT_SELECTED:
    'pg_act_communitiesofpractitioners_meetallofourpractitioners_selectcommunitytags_select',
  PRACTITIONERS_FILTERS_FAVORITE_TOGGLE_CLICKED:
    'pg_act_communitiesofpractitioners_meetallofourpractitioners_favourite',
  PRACTITIONERS_SIDEBAR_FILTERS_APPLIED:
    'pg_act_communitiesofpractitioners_meetallofourpractitioners_morefilters_apply',
  PRACTITIONERS_LIST_EXP_PROFILE_CLICKED:
    'pg_act_communitiesofpractitioners_meetallofourpractitioners_visitexperienceprofile',
  PRACTITIONERS_LIST_PAGINATION_NEXT_CLICKED: 'pg_act_communitiesofpractitioners_meetallofourpractitioners_moveright',
  PRACTITIONERS_LIST_PAGINATION_PREV_CLICKED: 'pg_act_communitiesofpractitioners_meetallofourpractitioners_moveleft',
  PRACTITIONER_VISIBILITY_SAVED: 'pg_act_communitiesofpractitioners_header_preferences_save',
  PRACTITIONERS_LIST_EMAIL_CLICKED: (name: string) =>
    `pg_act_communitiesofpractitioners_meetallofourpractitioners_${name}_contact`,
  PRACTITIONERS_CARD_VISIT_EXPERIENCE_PROFILE_CLICKED: (name: string) =>
    `pg_act_communitiesofpractitioners_wereheretohelp_${name}_visitexperienceprofile`,
  PRACTITIONERS_LIST_FAVORITE_TOGGLE_CLICKED: (name: string) =>
    `pg_act_communitiesofpractitioners_meetallofourpractitioners_${name}_favourite`,
}
